export default __webpack_public_path__ + "static/media/02__o_0.f8720c3d.jpg";